<template>
  <div>
    <div
      :class="{
        hideBottom: $store.state.hideBottom
      }"
    >
    </div>
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
})
</script>
<style lang="less" scoped>
.hideBottom {
  :deep(.vjs-control-bar) {
    bottom: 0;
  }
}
:deep(.el-tabs__active-bar) {
  transition: none;
}
:deep(.el-tabs__nav-wrap.is-top),
:deep(.el-tabs__item.is-top) {
  height: 30px;
}
:deep(.el-tabs__header){
  margin-bottom: 5px;
}
</style>
